import React from 'react';

const BRANDS = [
    { key: 'visa', label: 'Visa' },
    { key: 'amex', label: 'American Express' },
    { key: 'discover', label: 'Discover' },
];

const AcceptedCardBrands = () => {
    return (
        <div className="accepted-card-brands" role="list" aria-label="Accepted card types">
            {BRANDS.map((brand) => (
                <img
                    key={brand.key}
                    className="accepted-card-brands__chip"
                    src={`${process.env.PUBLIC_URL}/img/card-brands/${brand.key}.png`}
                    alt={brand.label}
                    role="listitem"
                />
            ))}
        </div>
    );
};

export default AcceptedCardBrands;
